import { render, staticRenderFns } from "./MiniBasketPDF.vue?vue&type=template&id=529c1fc2"
import script from "./MiniBasketPDF.vue?vue&type=script&lang=js"
export * from "./MiniBasketPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports